// Feed.jsx
'use strict';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';

import PullToRefresh from '../container/PullToRefresh.js';
import HomeSearchBar from '../container/HomeSearchBar.js';
import FeedComponent from '../container/FeedComponent.js';

import { headerHeight } from '../style/variables.js';
import media from '../style/media.js';

class Feed extends React.PureComponent {
  state = {
    shouldRefresh: false,
  };

  handleRefresh = async ({ reset }) => {
    this.setState({
      shouldRefresh: true,
    });
    setTimeout(() => {
      reset();
      this.setState({
        shouldRefresh: false,
      });
    });
  };

  getRefreshProps = () => {
    const { shouldRefresh } = this.state;
    return { shouldRefresh };
  };

  render() {
    const { categories, shouldRenderSearchBar } = this.props;
    return (
      <StyledFeed>
        <PullToRefresh useWindow onRefresh={this.handleRefresh}>
          <Body>
            {shouldRenderSearchBar && (
              <SearchBarWrapper>
                <HomeSearchBar />
              </SearchBarWrapper>
            )}
            {categories.map((category, index) => {
              const isLastCategory = index === categories.length - 1;
              return (
                <FeedComponent
                  {...this.getRefreshProps()}
                  key={category}
                  category={category}
                  index={index}
                  isLastCategory={isLastCategory}
                />
              );
            })}
          </Body>
        </PullToRefresh>
      </StyledFeed>
    );
  }
}

Feed.propTypes = {
  categories: PropTypes.array,
  shouldRenderSearchBar: PropTypes.bool,
};

Feed.defaultProps = {
  categories: [],
  shouldRenderSearchBar: false,
};

const StyledFeed = styled.div`
  padding-top: ${headerHeight}px;
  padding-bottom: ${({ isIphoneXSeriesPWA }) =>
    isIphoneXSeriesPWA ? '84px' : '50px'};
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Body = styled.div`
  margin: 0 auto;
  border-left: 1px solid rgba(100, 100, 100, 0.15);
  border-right: 1px solid rgba(100, 100, 100, 0.15);
  width: 100%;
  max-width: 680px;
  flex: auto;
  ${media.mobile`
    border-left: unset;
    border-right: unset;
  `};
`;

const SearchBarWrapper = styled.div`
  margin: 20px 0;
  padding: 0px 16px;
  display: none;
  ${media.tablet`
    margin: 12px 0;
    display: block;
  `}
  ${media.mobile`
    margin: 8px 0 12px;
    display: block;
  `}
`;

export default withTranslation()(Feed);
